// Default content values used as fallbacks when API content is not available
export const DEFAULT_CONTENT = {
  welcome: "Discover the most beautiful temples, heritage sites, and cultural landmarks with our expert guides and premium travel services.",
  
  // Add other default content values here as needed
  appTitle: "Aao Ghumen",
  description: "Explore amazing places with expert guidance",
  
  // SEO defaults
  descriptionSEO: "Discover temples, heritage sites, and cultural landmarks with expert guides and premium travel services",
  keywordSEO: "temples, heritage sites, cultural landmarks, travel, tour guide, India tourism",
  
  // Tour guide default messages
  appTourTimeTitle: "Select Time",
  appTourTimeDesc: "Choose your preferred travel time",
  appTourPlanTripTitle: "Plan Your Trip",
  appTourPlanTripDesc: "Create custom itineraries based on your preferences",
  appTourTripDetailTitle: "Trip Details", 
  appTourTripDetailDesc: "View and manage your trip information",
  appTourFilterTitle: "Filter Options",
  appTourFilterDesc: "Customize your experience with filters",
};

export default DEFAULT_CONTENT;
